<template>
  <el-form ref="formRef" :model="state.formData" :rules="rules" class="form-wrapper" @keyup.enter="onSubmit">
    <el-form-item prop="account">
      <el-input class="ipt-common" :placeholder="$t('form.emailTips')" v-model="state.formData.account" />
    </el-form-item>
    <el-form-item prop="code" @click.stop="() => { }">
      <VerifyCodeInput v-model:value="state.formData.code" ref="verifyCodeRef" />
    </el-form-item>
    <el-button class="submit-button" type="primary" @click="onSubmit" :loading="state.isLoading">
      {{ t('form.button.submit') }}
    </el-button>
    <div class="other-tool">
      <span class="text text1">{{ $t('form.registered') }}</span>
      <span class="text text2" @click="$emits('changeLoginStatus', 'login')">{{
        $t('form.loginNow')
      }}</span>
    </div>
  </el-form>
</template>

<script setup>
import { pwdVerifyMail } from '@/apis/user';
import reg from '@/utils/reg';
import { ElMessage } from 'element-plus';
import { defineEmits, reactive, ref, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import VerifyCodeInput from './VerifyCodeInput.vue';

const $emits = defineEmits(['changeLoginStatus']);
const { t } = useI18n();
const formRef = ref();
const verifyCodeRef = ref();
const $router = useRouter();
const state = reactive({
  isLoading: false,
  formData: {
    account: '',
    code: ''
  },
  rules: {
    account: [
      {
        required: true,
        trigger: 'blur',
        message: t('form.verifyEmpty')
      },
      {
        pattern: reg.mailReg,
        trigger: 'blur',
        message: t('form.holder.inputEmailAccount')
      }
    ],
    code: [
      {
        required: true,
        trigger: 'blur',
        message: t('form.verifyEmpty')
      }
    ]
  }
});
const { rules } = toRefs(state);
// 提交回调
const onSubmit = async () => {
  if (state.isLoading) return;
  state.isLoading = true;
  formRef.value.validate(async valid => {
    if (valid) {
      try {
        const params = {
          account: state.formData.account,
          uuid: verifyCodeRef.value.getId(),
          code: state.formData.code
        };
        await pwdVerifyMail(params);
        ElMessage({ message: t('common.emailSendSuccess'), type: 'success' });
        $router.push('/');
      } catch (error) {
        verifyCodeRef.value.getCodeImg();
        ElMessage({ message: error, type: 'error' });
      } finally {
        state.isLoading = false;
      }
    } else {
      state.isLoading = false;
    }
  });
};
</script>

<style lang="scss" scoped>
.form-wrapper {
  width: 400px;
  margin-top: 68px;

  .ipt-common {
    width: 400px;
    height: 44px;
  }

  .el-form-item {
    margin-bottom: 20px;
  }

  ::v-deep {
    .el-input {
      .el-input__inner {
        &::placeholder {
          font-family: Montserrat;
          font-size: 14px;
          color: #8492b2;
        }
      }

      .el-input__wrapper {
        height: 44px;
      }
    }
  }

  .submit-button {
    cursor: pointer;
    width: 400px;
    height: 56px;
    border-radius: 8px;
    text-align: center;
    line-height: 56px;
    background-color: var(--primary-color);
    // color: var(--white-color-1);
    margin-bottom: 24px;
    margin-top: 24px;
  }

  .other-tool {
    display: flex;
    justify-content: center;

    .text {
      font-family: Montserrat;
      font-size: 14px;
      color: var(--black-color-9);
    }

    .text2 {
      margin-left: 5px;
      color: var(--primary-color);
      cursor: pointer;
    }
  }
}
</style>
